// import { OneAccount } from "@hg/one-account"
import {
    getInviteCode,
    useExtraStatus,
    useJoinedTeam,
    usePageState,
} from "@hg/recall-frame"
import React, { FC, useEffect, useRef, useState } from "react"

import { CodeInputModal } from "../components/Modals/CodeInputModal"
import { Loader } from "./Loader"
import { Panel } from "./Panel"
import { Poster } from "./Poster"
import { Wrapper } from "./Wrapper"
import wrapperStyles from "./Wrapper/index.module.scss"

// const { useShowLoginDialog } = OneAccount.hooks

export const Home: FC = () => {
    const [ready, setReady] = useState(true)

    const { inviteOpen, setInviteOpen } = usePageState()

    const inviteCode = getInviteCode()

    const joinedTeam = useJoinedTeam()

    const statusSwr = useExtraStatus()

    const showInviteConfirmTimes = useRef(0)

    useEffect(() => {
        if (showInviteConfirmTimes.current > 0) {
            return
        }
        // 不符合条件不弹
        if (!statusSwr.data?.isRecallUser && !statusSwr.data?.isNewUser) {
            return
        }
        // 如果用户加入了team则不弹邀请弹窗
        if (!!joinedTeam.data) {
            return
        }
        if (inviteCode) {
            setInviteOpen(true)
            showInviteConfirmTimes.current = 1
        }
        return () => {
            setInviteOpen(false)
            showInviteConfirmTimes.current = 0
        }
    }, [inviteCode, joinedTeam.data, statusSwr.data, setInviteOpen])

    const onLoad = () => {
        setReady(true)
    }

    // const showLogin = useShowLoginDialog()

    return ready ? (
        <Wrapper ready={ready}>
            <div className={wrapperStyles.recallContent}>
                {/* 左侧抽奖部分 */}
                <Poster />
                {/* 右侧任务面板 */}
                <Panel />
            </div>
            {/* 邀请码填写弹窗 */}
            <CodeInputModal
                open={inviteOpen}
                onClose={() => setInviteOpen(false)}
            />
        </Wrapper>
    ) : (
        <Loader active={false} finished={ready} onFinish={onLoad} />
    )
}
